import { RunExternalDependency, RunExternalDependencyStatus } from "types/generated";

// Check if the user can skip external dependencies based on the status of the dependency
export const isExternalDependencySkippable = (dependency: RunExternalDependency): boolean =>
  dependency.status === RunExternalDependencyStatus.Pending;
